__turbopack_context__.v({
  "bordered": "style-module-scss-module__Dd6fAW__bordered",
  "circle": "style-module-scss-module__Dd6fAW__circle",
  "fill": "style-module-scss-module__Dd6fAW__fill",
  "initials-avatar": "style-module-scss-module__Dd6fAW__initials-avatar",
});
